import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class StockPriceTarget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
    }

    componentDidMount() {
        ApiService.getPriceTarget(this.state.symbol, this.state.limit).then(result => {
            console.log('Price Target', result);
            let filteredData = [];
            let length = this.state.limit === undefined ? 200 : this.state.limit;
            if (result.length > 0) {
                length = result.length < length ? result.length : length;
                for (var i = 0; i < length; i++) {
                    filteredData.push(result[i]);
                }
            }
            this.setState({ list: filteredData });
        })
            .catch((error) => {
                console.log(error);
            });
    }

    renderRow(listValue) {
        let resultColor = '';
        if (parseFloat(listValue.priceWhenPosted) <= parseFloat(listValue.priceTarget)) {
            resultColor = 'green';
        } else {
            resultColor = 'red';
        }
        return (
            <tr key={listValue.publishedDate + listValue.analystName + Math.random()} style={{ color: resultColor }}>
                <td style={{ color: resultColor, width: '12%'}}>{listValue.publishedDate.split('T')[0]}</td>
                <td style={{ color: resultColor}}>{listValue.analystCompany}</td>
                <div><a href={listValue.newsURL} target="_blank" rel="noreferrer" style={{ color: resultColor}}>{listValue.newsTitle}</a></div>
                <td style={{ color: resultColor}}>{listValue.priceWhenPosted.toFixed(0)}</td>
                <td style={{ color: resultColor}}>{listValue.priceTarget.toFixed(0)}</td>
            </tr>
        )
    }

    render() {
        let tableRow;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td><td></td><td></td></tr>
        } else {
            tableRow = this.state.list.map(this.renderRow.bind(this));
        }

        let header = 'Stock Price Target';
        if (this.state.limit !== undefined) {
            header = <><Link to={'/stockPriceTarget/' + this.state.symbol}>{header}</Link> <Link style={{ fontSize: "10px"}} to={'/stockGrade/' + this.state.symbol}>(More Details)</Link></>
        } else {
            header += ' - ' + this.state.symbol;
        }

        return (
            <div>
                {header}
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Company</th>
                            <th>News</th>
                            <th>Price When Posted</th>
                            <th>New Price Target&nbsp;&nbsp;
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                                        Hedge Funds/Big Investor sets new price target periodically based on the Company performance<br />
                                    </Tooltip>}>
                                    <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default StockPriceTarget;
